import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { PATH_PARAMETERS_LICENSE } from "~/modules/license/constants";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_LICENSE,
    component: () => import("~/modules/license/views/LicensePage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        !useLicenseStore().isLicenseDeactivated() &&
        can(ACLRoles.CAN_READ_LICENSE) &&
        (can(ACLRoles.CAN_READ_FEATURE) || can(ACLRoles.CAN_READ_DEVICE)),
      breadcrumb: BREADCRUMBS.LICENSE,
    },
  },
];

export default routes;
